import styled from 'styled-components';

import InputSimple from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Select from '@r1-frontend/ui-react/components/select/select';

export const Btn = styled.div<{isActive: boolean}>`
    width: 100%;
    cursor: pointer;
`;

export const AddressInputFields = styled.div`
    display: grid;
    flex-wrap: nowrap;
    grid-template-columns: 256px 256px 100px 100px;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    background-color: inherit;

    @media (max-width: ${wideBreakpoints.tablet}) {
        grid-template-columns: 226px 226px 100px 100px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-template-columns: 1fr 1fr;

        & > *:nth-child(1), *:nth-child(2) {
            grid-column-start: 1;   
            grid-column-end: 3;
        }
    }
`;

export const InputElement = styled(InputSimple)`
    margin-bottom: 0;
`;

export const DropDown = styled(Select)`
    width: 100%;
`;

export const DropdownIndicator = styled.div`
    width: 30px;
    height: 20px;
    background-image: url('${require('~/static/images/full-buy/map-baloon.svg')}');
    background-position: left center;
    background-repeat: no-repeat;
`;
